<template>
  <v-layout justify-space-between column fill-height>
    <v-container class="no-margins">
      <v-icon class="info-menu" small @click="$events.fire('showAbout', '')">$sl-info</v-icon>
      <template v-if="isLoggedIn && isRegistered">
        <v-container class="ml-2 mt-6">
          <v-icon size="40">$sl-user</v-icon>
          <h6 class="mt-6 mb-2 jakob-special-name">
            {{ currentUser.firstName + ' ' + currentUser.lastName }}
          </h6>
          <!-- <div class="jakob-special-company mt-0">{{ getCompanies() }}</div> -->
        </v-container>
      </template>

      <v-list class="mainmenu">
        <!-- START -->
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>$sl-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- SETTINGS -->
        <template v-if="isLoggedIn && isRegistered">
          <v-list-item :to="{name: 'PersonAddress'}">
            <v-list-item-icon>
              <v-icon>$sl-my-address</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.my-address') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{name: 'PersonSettings'}">
            <v-list-item-icon>
              <v-icon>$sl-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.my-settings') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <!-- PROFESSIONAL QUALIFICATIONS -->
        <template v-if="isLoggedIn && isRegistered && (isInstructor(0) || isApprentice || hasTradeCertificates)">
          <v-list-item :to="{name: 'PersonQualifications'}">
            <v-list-item-icon>
              <v-icon>$sl-trade-certificate</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.qualifications') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <!-- APPLICATION -->
        <template v-if="isLoggedIn && isRegistered && !isCompanyUser(0)">
          <v-list-item :to="{name: 'ApplicationStart', params: {setStep: 0}}">
            <v-list-item-icon>
              <v-icon>$sl-apprentice-application</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.application') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>  

        <template v-if="isLoggedIn && isRegistered && currentUser && ((isApprentice && currentUser.books) || (currentUser.tradeCertificates && currentUser.tradeCertificates.length>0))">
          <v-list-item :to="{name: 'MyOrderCardStart'}">
            <v-list-item-icon>
              <v-icon>$sl-invitation</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.person-orders-machine') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <template v-if="currentUser.books && isInstructor(0) != true">
            <v-list-item-group v-for="(item, index) in currentUser.books" :key="index">
              <v-list-item :to="{name: 'EbookStart', params: {id: item.id}}">
                <v-list-item-icon>
                  <v-icon>$sl-ebook</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-if="currentUser.books.length > 1">{{
                    $t('ebook.button-label') + ' ' + $options.filters.date(item.createdAt)
                  }}</v-list-item-title>
                  <v-list-item-title v-else>{{ $t('labels.my-book') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </template>
        </template>

        <!-- Instructor -->
        <template v-if="isLoggedIn && isRegistered && isInstructor(0)">
          <v-list-item :to="{ name: 'InstructorInstructions' }">
            <v-list-item-icon>
              <v-icon>$sl-book-flip</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.instructor-instruction') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isActiveInstructor" :to="{name: 'CompanyInstructorApprentices', params: {id: currentUser.id}}">
            <v-list-item-icon>
              <v-icon>$sl-apprentices</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.my-apprentice') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- If instructor has ebook -->
          <v-list-item v-if="currentUser.books.length && isInstructor(0) == true" :to="{name: 'InstructorEbooks', params: {id: currentUser.id}}">
            <v-list-item-icon>
              <v-icon>$sl-ebook</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.my-book') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- If instructor has apprentices with ebooks -->
          <!-- <v-list-item v-if="isInstructor(0) == true && apprenticesWithBasicEducation > 0" :to="{ name: 'ApprenticeEbooks' }">
            <v-list-item-icon>
              <v-icon>$sl-ebook</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.apprentice-books') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </template>

        <v-list-item v-if="isInstructor(0) || isCompanyUser(0) && apprenticesWithBasicEducation > 0" :to="{ name: 'ApprenticeEbooks' }">
            <v-list-item-icon>
              <v-icon>$sl-ebook</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.apprentice-books') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        <v-list-item v-if="get(currentUser, 'educations', []).some(o => o.qualificationTime)" :to="{name: 'PersonQualifyingTime', params: { id: currentUser.id } }">
          <v-list-item-icon>
            <v-icon>$sl-stairs-ascend</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('labels.my-qualifying-time') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- COMPANY USERS (YUA/ADMIN/DEA) -->
        <template v-if="isLoggedIn && isRegistered && isCompanyUser(0)">
          <template>
            <v-badge 
              overlap 
              color="red" 
              :content="formattedQualificationFinishedCount" 
              :value="qualificationFinishedCount"
              v-if="formattedQualificationFinishedCount.length"
            >
              <v-list-item :to="{name: 'ApprenticeQualifyingTime'}">
              <v-list-item-icon>
                <v-icon>$sl-stairs-ascend</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.apprentice-qualifying-time') }}</v-list-item-title>
              </v-list-item-content>
              </v-list-item>
            </v-badge>

            <v-list-item :to="{name: 'ApprenticeQualifyingTime'}" v-else>
              <v-list-item-icon>
                <v-icon>$sl-stairs-ascend</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.apprentice-qualifying-time') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isInstructor(0) == false &&
                (isCompanyEducationResponsible(0) ||
                  isDistanceEducationAdministrator(0) ||
                  isDepartmentAdministrator(0) ||
                  isAdministrator) && currentUser.books.length
              "
              :to="{name: 'InstructorEbooks', params: {id: currentUser.id}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-ebook</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.my-book') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </template>

          <!-- <v-list-item v-if="currentUser.apprenticeships.length" :to="{name: 'InstructorEbooks', params: {id: currentUser.id}}">
            <v-list-item-icon>
              <v-icon>$sl-ebook</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.apprentice-books') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-item :to="{name: 'PersonBasicEducationTime'}" v-if="apprenticesWithBasicEducation > 0">
            <v-list-item-icon>
              <v-icon>$sl-owl</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.e-book-label-secondary') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-for="(employment, i) in currentUser.employments ? currentUser.employments : []">
            <div class="pl-4 companyname" :key="`${i}-header`">
              {{ employment.company ? employment.company.name : $t('fields.the-company') }}
            </div>

            <v-list-item
              v-if="isCompanyUser(employment.companyId)"
              class="company-list-item"
              :key="`${i}-li-workplace`"
              :to="{name: 'CompanyWorkplaces', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-workplace</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.workplaces') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="isCompanyUser(employment.companyId)"
              class="company-list-item"
              :key="`${i}-li-printordercard`"
              :to="{name: 'CompanyOrderCardStart', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-invitation</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.person-orders-machine') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                (isAdministrator || isDepartmentAdministrator(employment.companyId)) &&
                hasDepartments(employment.companyId)
              "
              class="company-list-item"
              :key="`${i}-li-departments`"
              :to="{name: 'CompanyDepartments', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-departments</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('company.sections') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isDistanceEducationAdministrator(employment.companyId) ||
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator
              "
              class="company-list-item"
              :key="`${i}-li-approve`"
              :to="{
                name: 'CompanyDistanceOrders',
                params: {companyId: employment.companyId}
              }"
            >
              <v-list-item-icon>
                <v-icon>$sl-approve-distance-order</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.approve-distance-orders') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator ||
                isDistanceEducationAdministrator(employment.companyId)
              "
              class="company-list-item"
              :key="`${i}-li-exemption`"
              :to="{name: 'CompanyExemptions', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-single-neutral-actions-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ $t('labels.exemption') }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="
                isDistanceEducationAdministrator(employment.companyId) ||
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator
              "
              class="company-list-item"
              :key="`${i}-li-instructor`"
              :to="{name: 'CompanyInstructors', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-instructor</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.instructors') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isCompanyEducationResponsible(employment.companyId) ||
                isDistanceEducationAdministrator(employment.companyId) ||
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator
              "
              class="company-list-item"
              :key="`${i}-li-apprentice`"
              :to="{name: 'CompanyApprentices', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-apprentice</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.apprentices') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="
                isCompanyEducationResponsible(employment.companyId) ||
                isDistanceEducationAdministrator(employment.companyId) ||
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator
              "
              class="company-list-item"
              :key="`${i}-li-apprentice-application`"
              :to="{name: 'CompanyApplications', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-apprentice-application</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.applications') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="isCompanyUser(employment.companyId)"
              class="company-list-item"
              :key="`${i}-li-create-apprentice-application`"
              @click="
                $nextTick(() => {
                  $router.push({
                    name: 'CreateCompanyApplications',
                    params: {id: employment.companyId, setStep: 0}
                  })
                })
              "
            >
              <v-list-item-icon>
                <v-icon>$sl-add-application</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.add-new-applications') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="
                isAdministrator ||
                isDepartmentAdministrator(employment.companyId) ||
                isCompanyEducationResponsible(employment.companyId)
              "
              class="company-list-item"
              :key="`${i}-li-staff`"
              :to="{name: 'CompanyEmployees', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-staff</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.staff') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isAdministrator ||
                isDepartmentAdministrator(employment.companyId) ||
                isCompanyEducationResponsible(employment.companyId)
              "
              class="company-list-item"
              :key="`${i}-li-permissions`"
              :to="{
                name: 'CompanyEmployeesPermissions',
                params: {id: employment.companyId}
              }"
            >
              <v-list-item-icon>
                <v-icon>$sl-permissions</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.roles') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="isAdministrator || isDepartmentAdministrator(employment.companyId) || isCompanyEducationResponsible(employment.companyId)"
              class="company-list-item"
              :key="`${i}-li-pause`"
              :to="{name: 'CompanyPausedPersons', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-pause</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.pause') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                isCompanyEducationResponsible(employment.companyId) ||
                isDistanceEducationAdministrator(employment.companyId) ||
                isDepartmentAdministrator(employment.companyId) ||
                isAdministrator
              "
              class="company-list-item"
              :key="`${i}-li-yua`"
              :to="{name: 'CompanyYUA', params: {id: employment.companyId}}"
            >
              <v-list-item-icon>
                <v-icon>$sl-yua</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('labels.yua') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>

        <template v-if="isLoggedIn">
          <v-list-item @click="showLogoutModal = true">
            <v-list-item-icon>
              <v-icon>$sl-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('menu.logout') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item :to="{name: 'Guide'}" v-if="isInstructor(0) || isAdministrator || isDepartmentAdministrator(0)">
            <v-list-item-icon>
              <v-icon>$sl-guide</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('tour.menu') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item @click="helpClick()" class="my-1">
          <v-list-item-icon>
            <v-icon>$sl-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.help') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          href="mailto:support@byn.se" 
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>$sl-send</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.contact-support') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          href="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2023/06/Manual-Mina-Sidor.pdf" 
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>$sl-manual</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.manual') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          href="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/11/Mall-utvecklingsplan-2406.docx" 
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>$sl-write</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.development-plan') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          href="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/05/Franvaroberakning_kvalificeringstid.xlsx" 
          target="_blank"
          title="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/05/Franvaroberakning_kvalificeringstid.xlsx"
        >
          <v-list-item-icon>
            <v-icon>$sl-task-list-approve</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.absence-calculator-qualifying-time') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          href="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/11/Mall-tjanstgoringsintyg-2406.docx" 
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>$sl-trade-certificate</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.service-certificate') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>

    <v-list>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>$sl-translate</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            <LocaleChanger class="menu-changer" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <ModalBase
      :show="showLogoutModal"
      maxWidth="400px"
      :title="$t('menu.logout-title')"
      cancelIcon="$sl-cancel"
      submitIcon="$sl-logout"
      :cancelText="$t('labels.cancel')"
      :submitText="$t('menu.logout-btn')"
      @close="showLogoutModal = false"
      @cancel="showLogoutModal = false"
      @submit="logoutClick"
    />
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import LocaleChanger from '@/components/Common/LocaleChanger'
import {CompanyRoles} from '@/components/mixins'
import ModalBase from '@/components/Common/ModalBase'
import get from 'lodash/get'
const SugarDate = require('sugar/date')
import API from '@/services/api'

// @group Common
// Provides the application menu
//
// Will display a logged out, instructor or apprentice menu based on currentUser
// @vuese
export default {
  name: 'AppMenu',

  mixins: [CompanyRoles],

  components: {
    LocaleChanger,
    ModalBase
  },

  data() {
    return {
      showLogoutModal: false,
      apprenticesWithBasicEducation: null,
      qualificationFinishedCount: null
    }
  },

  created() {
    this.qualificationFinishedCount = null
  },

  watch: {
    '$route.name'(newName, oldName) {
      if (oldName === 'ApprenticeQualifyingTime' && this.isLoggedIn) {
        this.setQualifyingApprovalCount()
      }
    },
    currentUser() {
      if ( !this.isLoggedIn ) return
      this.fetchApprenticeBasicEducation()
      this.setQualifyingApprovalCount()
    }
  },

  computed: {
    ...mapGetters('currentuser', [
      'currentUser',
      'isRegistered',
      'isLoggedIn',
      'isApprentice',
      'isCompanyUser',
      'isInstructor',
      'isAdministrator',
      'isCompanyEducationResponsible',
      'isDistanceEducationAdministrator',
      'isDepartmentAdministrator',
      'hasTradeCertificates'
    ]),
    
    hasQualificationTime() {
      return Boolean(
        this.currentUser.educations.find(
          e =>
            (e.qualificationTime != null &&
            SugarDate.Date.isBetween(new Date(), e.qualificationTime.fromDate, e.qualificationTime.toDate))
              ||
            (e.qualificationTime != null &&
            e.qualificationTime.isCancelled)
        )
      )
    },

    isActiveInstructor() {
      return this.isInstructor(0) && this.currentUser?.employments?.some(e => e.apprenticeshipInstructors?.some(a => a.isActive))
    },

    formattedQualificationFinishedCount() {
      return `${ this.qualificationFinishedCount > 9 ? 9 + '+' : this.qualificationFinishedCount }`
    },
  },

  methods: {
    get,

    async setQualifyingApprovalCount() {
      try {

        const { data } = await API.getApprenticesQualifyingTimes()

        const apprentices = (data || [])
          .filter(({ personalNumber }) => personalNumber && personalNumber !== get(this, 'currentUser.personalNumber', null))

        const qualificationTimes = apprentices.flatMap(({ educations }) => 
          (educations || []).map(education => get(education, 'qualificationTime', null)))

        this.qualificationFinishedCount = qualificationTimes.reduce((sum, qt) => {
          const endDateHasPassed = SugarDate.Date(qt.toDate).isBefore().raw
          const isActive = !qt.doAbort && !qt.isCancelled && !qt.isApprovedByInstructor
          return sum + (endDateHasPassed && isActive ? 1 : 0)
        }, 0)
      } catch (error) {
        console.log('An error has occured:', error)
      }
    },

    fetchApprenticeBasicEducation() {
      if ( this.isLoggedIn ) {
        API.listBooks().then(({data = []}) => {
          const filteredApprenticies = data.filter(d => d.personId !== this.currentUser.id)
          this.apprenticesWithBasicEducation = filteredApprenticies.length
        })
        .catch(error => {
          console.log('Error getting apprenticies QT:', error)
        })
      }
    },
    
    openFeedback() {
      if (window.Userback) {
        window.Userback.open()
      }
    },
    helpClick() { 
      window.open('https://www.byggbranschensyrkesnamnd.se/manual/kategorier/mina-sidor/', '_blank')
    },
    getCompanies() {
      if (!this.currentUser) {
        return
      }
      var ret = this.currentUser.employments.map(o => (o.company ? o.company.name : '')).join(', ')
      return ret
    },

    logoutClick() {
      this.showLogoutModal = false
      this.$emit('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
div.v-list.mainmenu.v-sheet.v-sheet--tile.theme--light {
  .v-list-item {
    padding-left: 16px !important;
  }
  .company-list-item {
    padding-left: 26px !important;
  }
  .companyname {
    font-family: 'Dosis', sans-serif !important;
    letter-spacing: 0.15px;
    font-size: 16px !important;
    margin-top: 13px !important;
    margin-bottom: 14px !important;
    color: var(--v-primary-darken5) !important;
    font-weight: 500 !important;
  }
}
.jakob-special-name {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #3b3c3a;
}
</style>
